import { observer } from 'mobx-react';
import { InfoBar } from 'owa-info-bar-view';
import { createInfoBarViewState } from 'owa-mail-reading-pane-infobar';
import ItemViewState from 'owa-mail-reading-pane-store/lib/store/schema/ItemViewState';
import { logRPCountInfoBarDatapoints } from '../utils/logInfoBarDatapoints';
import { ClientMessage, InstrumentationContext } from 'owa-mail-store';
import * as React from 'react';
import { computed } from 'mobx';
import InfoBarViewState from 'owa-info-bar/lib/schema/InfoBarViewState';

const styles = require('./ItemHeaderInfoBar.scss');
const classNames = require('classnames');

export interface ItemHeaderInfoBarProps {
    message: ClientMessage;
    viewState: ItemViewState;
    instrumentationContext: InstrumentationContext;
    className?: string;
}

@observer
export default class ItemHeaderInfoBar extends React.Component<ItemHeaderInfoBarProps, any> {
    @computed
    get infoBarViewState(): InfoBarViewState {
        const { message, viewState, instrumentationContext } = this.props;
        return createInfoBarViewState(message, [instrumentationContext], viewState);
    }

    componentDidMount() {
        logRPCountInfoBarDatapoints(this.infoBarViewState.messages);
    }

    render() {
        return (
            <InfoBar
                {...this.infoBarViewState}
                textContainerClassName={styles.infoBarTextContainer}
                className={classNames(styles.infoBar, 'allowTextSelection', this.props.className)}
            />
        );
    }
}
